/**
 * 邀請碼綁新瓦斯行開新身分（設計 docs/2026-09-03-invite-code-supplier-context-design.md §4）的純函式。
 */
import { OA_ENTRY_PREFERRED_CONTEXT_KEY } from "./oaEntryCheck";

/** 綁定/加入成功後記一次性偏好身分：身分選單下次載入自動切過去。
 *  context_id 缺席（舊後端／加入家庭情境）→ 不動作，行為與未升級前相同。 */
export const rememberPreferredContext = (contextId: number | null | undefined): void => {
  if (contextId == null) return;
  try {
    sessionStorage.setItem(OA_ENTRY_PREFERRED_CONTEXT_KEY, String(contextId));
  } catch {
    // 寫不進去（隱私模式等）就算了：只是少了自動切，功能不受影響
  }
};
